import React from 'react';
import { IProps } from './interfaces';

const KrClaim: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5776_2237)">
        <path
          d="M16 1.97999C23.83 1.97999 30.2 8.34999 30.2 16.18C30.2 24.01 23.83 30.38 16 30.38C8.17 30.38 1.8 24.01 1.8 16.18C1.8 8.34999 8.17 1.97999 16 1.97999ZM16 0.179993C7.16 0.179993 0 7.34999 0 16.18C0 25.01 7.16 32.18 16 32.18C24.84 32.18 32 25.02 32 16.18C32 7.33999 24.84 0.179993 16 0.179993Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 6.39001C16.4971 6.39001 16.9 6.79296 16.9 7.29001V18.11C16.9 18.6071 16.4971 19.01 16 19.01C15.5029 19.01 15.1 18.6071 15.1 18.11V7.29001C15.1 6.79296 15.5029 6.39001 16 6.39001ZM16 21.55C16.4971 21.55 16.9 21.953 16.9 22.45V25.08C16.9 25.5771 16.4971 25.98 16 25.98C15.5029 25.98 15.1 25.5771 15.1 25.08V22.45C15.1 21.953 15.5029 21.55 16 21.55Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5776_2237">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KrClaim;
